"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: card/card.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcard%2Fcard.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const card_atm_1 = require("../common/card-atm");
const card_details_1 = require("../common/card-details");
const card_issuer_1 = require("../common/card-issuer");
const card_wallets_1 = require("../common/card-wallets");
const date_1 = require("../common/date");
const card_category_1 = require("./card-category");
const step_card_design_1 = require("./step-card-design");
const protobufPackage = 'com.step.account.proto';
function createBaseCard() {
    return {
        id: '',
        userId: '',
        panSuffix: '',
        expirationDate: undefined,
        nameOnCard: '',
        cardType: card_details_1.CardType.INVALID_CARD_TYPE,
        cardStatus: card_details_1.CardStatus.INVALID_CARD_STATUS,
        shipping: undefined,
        createdAtMs: '0',
        updatedAtMs: '0',
        activatedAtMs: '0',
        closedAtMs: '0',
        replacedBy: '',
        replacementReason: card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON,
        isReplaced: false,
        atm: undefined,
        pinStatus: card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS,
        wallets: undefined,
        issuer: card_issuer_1.CardIssuer.INVALID_CARD_ISSUER,
        cardProgramType: card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE,
        design: undefined,
        cardCategory: card_category_1.CardCategory.INVALID_CARD_CATEGORY,
    };
}
exports.Card = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            nameOnCard: isSet(object.nameOnCard) ? globalThis.String(object.nameOnCard) : '',
            cardType: isSet(object.cardType)
                ? (0, card_details_1.cardTypeFromJSON)(object.cardType)
                : card_details_1.CardType.INVALID_CARD_TYPE,
            cardStatus: isSet(object.cardStatus)
                ? (0, card_details_1.cardStatusFromJSON)(object.cardStatus)
                : card_details_1.CardStatus.INVALID_CARD_STATUS,
        };
        if (isSet(object.panSuffix)) {
            message.panSuffix = globalThis.String(object.panSuffix);
        }
        if (isSet(object.expirationDate)) {
            message.expirationDate = date_1.ExpirationDate.fromJSON(object.expirationDate);
        }
        if (isSet(object.shipping)) {
            message.shipping = card_details_1.CardShipping.fromJSON(object.shipping);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        if (isSet(object.activatedAtMs)) {
            message.activatedAtMs = globalThis.String(object.activatedAtMs);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        if (isSet(object.replacedBy)) {
            message.replacedBy = globalThis.String(object.replacedBy);
        }
        if (isSet(object.replacementReason)) {
            message.replacementReason = (0, card_details_1.cardReplacementReasonFromJSON)(object.replacementReason);
        }
        if (isSet(object.isReplaced)) {
            message.isReplaced = globalThis.Boolean(object.isReplaced);
        }
        if (isSet(object.atm)) {
            message.atm = card_atm_1.CardAtm.fromJSON(object.atm);
        }
        if (isSet(object.pinStatus)) {
            message.pinStatus = (0, card_atm_1.cardPinStatusFromJSON)(object.pinStatus);
        }
        if (isSet(object.wallets)) {
            message.wallets = card_wallets_1.Wallets.fromJSON(object.wallets);
        }
        if (isSet(object.issuer)) {
            message.issuer = (0, card_issuer_1.cardIssuerFromJSON)(object.issuer);
        }
        if (isSet(object.cardProgramType)) {
            message.cardProgramType = (0, card_details_1.cardProgramTypeFromJSON)(object.cardProgramType);
        }
        if (isSet(object.design)) {
            message.design = step_card_design_1.StepCardDesign.fromJSON(object.design);
        }
        if (isSet(object.cardCategory)) {
            message.cardCategory = (0, card_category_1.cardCategoryFromJSON)(object.cardCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.panSuffix !== undefined && message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.expirationDate !== undefined) {
            obj.expirationDate = date_1.ExpirationDate.toJSON(message.expirationDate);
        }
        if (message.nameOnCard !== '') {
            obj.nameOnCard = message.nameOnCard;
        }
        if (message.cardType !== card_details_1.CardType.INVALID_CARD_TYPE) {
            obj.cardType = (0, card_details_1.cardTypeToJSON)(message.cardType);
        }
        if (message.cardStatus !== card_details_1.CardStatus.INVALID_CARD_STATUS) {
            obj.cardStatus = (0, card_details_1.cardStatusToJSON)(message.cardStatus);
        }
        if (message.shipping !== undefined) {
            obj.shipping = card_details_1.CardShipping.toJSON(message.shipping);
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.activatedAtMs !== undefined && message.activatedAtMs !== '0') {
            obj.activatedAtMs = message.activatedAtMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        if (message.replacedBy !== undefined && message.replacedBy !== '') {
            obj.replacedBy = message.replacedBy;
        }
        if (message.replacementReason !== undefined &&
            message.replacementReason !== card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON) {
            obj.replacementReason = (0, card_details_1.cardReplacementReasonToJSON)(message.replacementReason);
        }
        if (message.isReplaced !== undefined && message.isReplaced !== false) {
            obj.isReplaced = message.isReplaced;
        }
        if (message.atm !== undefined) {
            obj.atm = card_atm_1.CardAtm.toJSON(message.atm);
        }
        if (message.pinStatus !== undefined && message.pinStatus !== card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS) {
            obj.pinStatus = (0, card_atm_1.cardPinStatusToJSON)(message.pinStatus);
        }
        if (message.wallets !== undefined) {
            obj.wallets = card_wallets_1.Wallets.toJSON(message.wallets);
        }
        if (message.issuer !== undefined && message.issuer !== card_issuer_1.CardIssuer.INVALID_CARD_ISSUER) {
            obj.issuer = (0, card_issuer_1.cardIssuerToJSON)(message.issuer);
        }
        if (message.cardProgramType !== undefined &&
            message.cardProgramType !== card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE) {
            obj.cardProgramType = (0, card_details_1.cardProgramTypeToJSON)(message.cardProgramType);
        }
        if (message.design !== undefined) {
            obj.design = step_card_design_1.StepCardDesign.toJSON(message.design);
        }
        if (message.cardCategory !== undefined &&
            message.cardCategory !== card_category_1.CardCategory.INVALID_CARD_CATEGORY) {
            obj.cardCategory = (0, card_category_1.cardCategoryToJSON)(message.cardCategory);
        }
        return obj;
    },
    create(base) {
        return exports.Card.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCard();
        message.id = object.id ?? '';
        message.userId = object.userId ?? '';
        message.panSuffix = object.panSuffix ?? '';
        message.expirationDate = (object.expirationDate !== undefined && object.expirationDate !== null)
            ? date_1.ExpirationDate.fromPartial(object.expirationDate)
            : undefined;
        message.nameOnCard = object.nameOnCard ?? '';
        message.cardType = object.cardType ?? card_details_1.CardType.INVALID_CARD_TYPE;
        message.cardStatus = object.cardStatus ?? card_details_1.CardStatus.INVALID_CARD_STATUS;
        message.shipping = (object.shipping !== undefined && object.shipping !== null)
            ? card_details_1.CardShipping.fromPartial(object.shipping)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.activatedAtMs = object.activatedAtMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        message.replacedBy = object.replacedBy ?? '';
        message.replacementReason = object.replacementReason ??
            card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON;
        message.isReplaced = object.isReplaced ?? false;
        message.atm = (object.atm !== undefined && object.atm !== null)
            ? card_atm_1.CardAtm.fromPartial(object.atm)
            : undefined;
        message.pinStatus = object.pinStatus ?? card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS;
        message.wallets = (object.wallets !== undefined && object.wallets !== null)
            ? card_wallets_1.Wallets.fromPartial(object.wallets)
            : undefined;
        message.issuer = object.issuer ?? card_issuer_1.CardIssuer.INVALID_CARD_ISSUER;
        message.cardProgramType = object.cardProgramType ?? card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        message.design = (object.design !== undefined && object.design !== null)
            ? step_card_design_1.StepCardDesign.fromPartial(object.design)
            : undefined;
        message.cardCategory = object.cardCategory ?? card_category_1.CardCategory.INVALID_CARD_CATEGORY;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card.js.map